import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next/src';
import { formatLocal } from '@hobs/utils/formatWithTimeZone';
import { DATE_FORMAT, DATETIME_FORMAT } from '@hobs/utils/constants';

function getLatestEditedFieldName(
  defaultField,
  editedFields = [],
  additionalFields = []
) {
  const editedFieldsInfo = additionalFields
    .reduce((result, field) => {
      const editedField = editedFields.find(
        editedField => editedField.editedFieldName === field
      );

      if (editedField !== undefined) {
        result.push(editedField);
      }

      return result;
    }, [])
    .sort(
      (a, b) =>
        new Date(b.changedDate).getTime() - new Date(a.changedDate).getTime()
    );

  if (editedFieldsInfo.length) {
    return editedFieldsInfo[0].editedFieldName;
  }

  return defaultField;
}

const FieldHistoryMessage = (
  fieldName,
  editedFields = [],
  additionalFields = []
) => {
  if (!editedFields.length) {
    return null;
  }
  additionalFields.push(fieldName);

  const editedFieldName = getLatestEditedFieldName(
    fieldName,
    editedFields,
    additionalFields
  );

  const editedField = editedFields.find(
    field => field.editedFieldName === editedFieldName
  );
  if (!editedField) {
    return null;
  }

  const changeDate = formatLocal(editedField.changedDate, DATETIME_FORMAT);

  return (
    <>
      {!editedField.changedBy ? (
        <div>
          <Translation>{t => t('Requested change')}</Translation>:{' '}
          {editedField.newDateValue
            ? formatLocal(editedField.newDateValue, DATE_FORMAT)
            : editedField.newValue
              ? String(editedField.newValue)
              : '-'}
        </div>
      ) : (
        <>
          <div>
            <Translation>{t => t('Changed by')}</Translation>{' '}
            {editedField.changedBy} on{' '}
          </div>
          <div>{changeDate}</div>
        </>
      )}
    </>
  );
};

FieldHistoryMessage.propTypes = {
  fieldName: PropTypes.string,
  editedFields: PropTypes.array,
  additionalFields: PropTypes.array
};

export default FieldHistoryMessage;
